import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["stopReload"]
  static values = { interval: Number }

  disconnect() {
    clearInterval(this.i)
    this.element.removeEventListener("turbo:frame-missing", this.visitPage)
  }

  connect() {
    // A page that no longer has this frame (a finished build, say) has moved
    // on to another layout, so load it whole rather than show "Content
    // missing". An error or a redirect (to sign in, say) just stops the
    // reloads, leaving the page and anything typed on it alone.
    this.visitPage = (event) => {
      event.preventDefault()
      const { response, visit } = event.detail
      if (response.ok && !response.redirected) visit(response)
      else clearInterval(this.i)
    }
    this.element.addEventListener("turbo:frame-missing", this.visitPage)

    if (this.hasStopReloadTarget) return

    let interval = this.intervalValue || 3000
    this.i = setInterval(() => {
      if (this.hasStopReloadTarget) {
        clearInterval(this.i)
        return
      }

      if (!this.element.checkVisibility()) return

      Turbo.visit(window.location, { frame: this.element.id })
    }, interval)
  }
}
